/** portfolio 全体で固定利用するタイムゾーン。 */
export const portfolioTimezone = 'Asia/Tokyo' as const
